import { Caption, mq, resetButtonStyle, Subtitle } from '@kvdbil/components';
import styled from 'styled-components';

export const RegistrationContainer = styled.div`
  text-align: center;
  margin: 0 auto;
  max-width: 520px;

  ${mq(null, 'tablet')} {
    max-width: 100%;
  }
`;

export const RegistrationBox = styled.div`
  position: relative;
  z-index: 1;
  padding: 0 1rem;

  ${mq('tablet')} {
    padding: 0 2rem;
  }
`;

export const RegistrationContent = styled.div`
  margin: 0 auto;
  max-width: 420px;
`;

export const RegistrationDescription = styled.div`
  font-size: 0.9rem;
  margin: 2rem auto;

  ${mq('tablet')} {
    text-align: left;
  }
`;

export const RegistrationHeading = styled(Subtitle).attrs({ as: 'h2' })``;

export const RegistrationFormContainer = styled.div`
  font-size: 13px;
  margin-top: 0.5rem;
  text-align: left;
`;

export const RegistrationRelatedLink = styled.button`
  ${resetButtonStyle};
  text-decoration: underline;
  color: ${({ theme }) => theme.colors.grayscaleToned.light1};
`;

export const RegistrationSubtleSuccess = styled.span`
  color: ${({ theme }) => theme.colors.secondary.main};
`;

export const RegistrationDisclaimer = styled(Caption)`
  color: ${({ theme }) => theme.colors.grayscaleToned.light1};
  margin-left: auto;
  margin-right: auto;
  max-width: 240px;
  margin-top: 1.5rem;
`;

export const RegistrationDividerText = styled(Caption)`
  text-align: center;
  margin-bottom: 1.5rem;
`;
